var _slicedToArray = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _defineProperty = require("/codebuild/output/src538327727/src/actions-runner/_work/www-lwb-org-au/www-lwb-org-au/node_modules/@babel/runtime/helpers/defineProperty.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var is = require('./is.js');
var misc = require('./misc.js');
var normalize = require('./normalize.js');
var object = require('./object.js');

/**
 * Extracts stack frames from the error.stack string
 */
function parseStackFrames(stackParser, error) {
  return stackParser(error.stack || '', 1);
}

/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */
function exceptionFromError(stackParser, error) {
  var exception = {
    type: error.name || error.constructor.name,
    value: error.message
  };
  var frames = parseStackFrames(stackParser, error);
  if (frames.length) {
    exception.stacktrace = {
      frames: frames
    };
  }
  return exception;
}

/** If a plain object has a property that is an `Error`, return this error. */
function getErrorPropertyFromObject(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      var value = obj[prop];
      if (value instanceof Error) {
        return value;
      }
    }
  }
  return undefined;
}
function getMessageForObject(exception) {
  if ('name' in exception && typeof exception.name === 'string') {
    var message = "'".concat(exception.name, "' captured as exception");
    if ('message' in exception && typeof exception.message === 'string') {
      message += " with message '".concat(exception.message, "'");
    }
    return message;
  } else if ('message' in exception && typeof exception.message === 'string') {
    return exception.message;
  }
  var keys = object.extractExceptionKeysForMessage(exception);

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if (is.isErrorEvent(exception)) {
    return "Event `ErrorEvent` captured as exception with message `".concat(exception.message, "`");
  }
  var className = getObjectClassName(exception);
  return "".concat(className && className !== 'Object' ? "'".concat(className, "'") : 'Object', " captured as exception with keys: ").concat(keys);
}
function getObjectClassName(obj) {
  try {
    var prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}
function getException(client, mechanism, exception, hint) {
  if (is.isError(exception)) {
    return [exception, undefined];
  }

  // Mutate this!
  mechanism.synthetic = true;
  if (is.isPlainObject(exception)) {
    var normalizeDepth = client === null || client === void 0 ? void 0 : client.getOptions().normalizeDepth;
    var extras = _defineProperty({}, '__serialized__', normalize.normalizeToSize(exception, normalizeDepth));
    var errorFromProp = getErrorPropertyFromObject(exception);
    if (errorFromProp) {
      return [errorFromProp, extras];
    }
    var message = getMessageForObject(exception);
    var _ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(message);
    _ex.message = message;
    return [_ex, extras];
  }

  // This handles when someone does: `throw "something awesome";`
  // We use synthesized Error here so we can extract a (rough) stack trace.
  var ex = (hint === null || hint === void 0 ? void 0 : hint.syntheticException) || new Error(exception);
  ex.message = "".concat(exception);
  return [ex, undefined];
}

/**
 * Builds and Event from a Exception
 * @hidden
 */
function eventFromUnknownInput(client, stackParser, exception, hint) {
  var providedMechanism = (hint === null || hint === void 0 ? void 0 : hint.data) && hint.data.mechanism;
  var mechanism = providedMechanism || {
    handled: true,
    type: 'generic'
  };
  var _getException = getException(client, mechanism, exception, hint),
    _getException2 = _slicedToArray(_getException, 2),
    ex = _getException2[0],
    extras = _getException2[1];
  var event = {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
  if (extras) {
    event.extra = extras;
  }
  misc.addExceptionTypeValue(event, undefined, undefined);
  misc.addExceptionMechanism(event, mechanism);
  return _objectSpread(_objectSpread({}, event), {}, {
    event_id: hint === null || hint === void 0 ? void 0 : hint.event_id
  });
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(stackParser, message) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
  var hint = arguments.length > 3 ? arguments[3] : undefined;
  var attachStacktrace = arguments.length > 4 ? arguments[4] : undefined;
  var event = {
    event_id: hint === null || hint === void 0 ? void 0 : hint.event_id,
    level: level
  };
  if (attachStacktrace && hint !== null && hint !== void 0 && hint.syntheticException) {
    var frames = parseStackFrames(stackParser, hint.syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{
          value: message,
          stacktrace: {
            frames: frames
          }
        }]
      };
      misc.addExceptionMechanism(event, {
        synthetic: true
      });
    }
  }
  if (is.isParameterizedString(message)) {
    var __sentry_template_string__ = message.__sentry_template_string__,
      __sentry_template_values__ = message.__sentry_template_values__;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}
exports.eventFromMessage = eventFromMessage;
exports.eventFromUnknownInput = eventFromUnknownInput;
exports.exceptionFromError = exceptionFromError;
exports.parseStackFrames = parseStackFrames;